export default __webpack_public_path__ + "static/media/SWT0540.34I-38168_-22458_0.2788e3c5.jpg";